@file:OptIn(InternalResourceApi::class)

package com.parmartechnologies.app.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/com.parmartechnologies.app.composeapp.generated.resources/"

internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.brand_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:brand_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.business_app_icon: DrawableResource by lazy {
      DrawableResource("drawable:business_app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/business_app_icon.icns", -1, -1),
      ))
    }

internal val Res.drawable.business_logo_web: DrawableResource by lazy {
      DrawableResource("drawable:business_logo_web", setOf(
        ResourceItem(setOf(), "${MD}drawable/business_logo_web.png", -1, -1),
      ))
    }

internal val Res.drawable.business_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:business_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/business_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.catalogue_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:catalogue_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/catalogue_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.category_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:category_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/category_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.colors: DrawableResource by lazy {
      DrawableResource("drawable:colors", setOf(
        ResourceItem(setOf(), "${MD}drawable/colors.png", -1, -1),
      ))
    }

internal val Res.drawable.customer_app: DrawableResource by lazy {
      DrawableResource("drawable:customer_app", setOf(
        ResourceItem(setOf(), "${MD}drawable/customer_app.png", -1, -1),
      ))
    }

internal val Res.drawable.customer_app_bkp: DrawableResource by lazy {
      DrawableResource("drawable:customer_app_bkp", setOf(
        ResourceItem(setOf(), "${MD}drawable/customer_app_bkp.png", -1, -1),
      ))
    }

internal val Res.drawable.customer_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:customer_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/customer_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.dashboard_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:dashboard_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/dashboard_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.employee_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:employee_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/employee_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.invoice_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:invoice_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/invoice_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.message_icon: DrawableResource by lazy {
      DrawableResource("drawable:message_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/message_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.orders_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:orders_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/orders_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.partner_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:partner_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/partner_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.product_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:product_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.quotation_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:quotation_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/quotation_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.sale_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:sale_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/sale_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.share_icon: DrawableResource by lazy {
      DrawableResource("drawable:share_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/share_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.shop_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:shop_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/shop_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.store_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:store_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/store_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.sub_category_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:sub_category_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/sub_category_menu_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.support_image: DrawableResource by lazy {
      DrawableResource("drawable:support_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/support_image.png", -1, -1),
      ))
    }

internal val Res.drawable.whatsapp_icon: DrawableResource by lazy {
      DrawableResource("drawable:whatsapp_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/whatsapp_icon.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_icon", Res.drawable.app_icon)
  map.put("brand_menu_icon", Res.drawable.brand_menu_icon)
  map.put("business_app_icon", Res.drawable.business_app_icon)
  map.put("business_logo_web", Res.drawable.business_logo_web)
  map.put("business_menu_icon", Res.drawable.business_menu_icon)
  map.put("catalogue_menu_icon", Res.drawable.catalogue_menu_icon)
  map.put("category_menu_icon", Res.drawable.category_menu_icon)
  map.put("colors", Res.drawable.colors)
  map.put("customer_app", Res.drawable.customer_app)
  map.put("customer_app_bkp", Res.drawable.customer_app_bkp)
  map.put("customer_menu_icon", Res.drawable.customer_menu_icon)
  map.put("dashboard_menu_icon", Res.drawable.dashboard_menu_icon)
  map.put("employee_menu_icon", Res.drawable.employee_menu_icon)
  map.put("invoice_menu_icon", Res.drawable.invoice_menu_icon)
  map.put("message_icon", Res.drawable.message_icon)
  map.put("orders_menu_icon", Res.drawable.orders_menu_icon)
  map.put("partner_menu_icon", Res.drawable.partner_menu_icon)
  map.put("product_menu_icon", Res.drawable.product_menu_icon)
  map.put("quotation_menu_icon", Res.drawable.quotation_menu_icon)
  map.put("sale_menu_icon", Res.drawable.sale_menu_icon)
  map.put("share_icon", Res.drawable.share_icon)
  map.put("shop_menu_icon", Res.drawable.shop_menu_icon)
  map.put("store_menu_icon", Res.drawable.store_menu_icon)
  map.put("sub_category_menu_icon", Res.drawable.sub_category_menu_icon)
  map.put("support_image", Res.drawable.support_image)
  map.put("whatsapp_icon", Res.drawable.whatsapp_icon)
}
